import { Flex, theme } from "antd";
import CardPortfolio from "../../../../../proposal/component/CardPortfolio";

import StyledContainer from "./style";

const CardTopProduct = ({
  onClickProductDetails,
  quantitySavedProposal,
  productData,
  place,
}) => {
  const { token } = theme.useToken();

  return (
    <StyledContainer token={token}>
      <Flex align="center" className="label-place" justify="center" vertical>
        <h5>#{place}</h5>
        <p>{Math.round((productData.y / quantitySavedProposal) * 100)}%</p>
      </Flex>

      <CardPortfolio
        handleButtonDetails={() =>
          onClickProductDetails(productData?.productData?._id)
        }
        riskScore={productData?.productData?.riskScore}
        riskTolerance={productData?.productData?.riskTolerance}
        title={productData?.name}
      />
    </StyledContainer>
  );
};

export default CardTopProduct;
